import Log from '@utils/log';
import jQuery from 'jquery';

const MAX_RATING = 5;
const MIN_RATING = 0;
const MIN_RATING_TO_SHOW = 4;

const ratingToColor = {
  1: 'color_one_star',
  1.5: 'color_one_half_star',
  2: 'color_two_star',
  2.5: 'color_two_half_star',
  3: 'color_three_star',
  3.5: 'color_three_half_star',
  4: 'color_four_star',
  4.5: 'color_four_half_star',
  5: 'color_five_star',
};

const configDataForRating = (rating, config) => {
  if (rating && config && config.ratings && rating.site_url) {
    let siteUrl = rating.site_url.toLowerCase();

    for (var i = 0; i < config.ratings.length; i++) {
      let data = config.ratings[i];
      let urls = data.urls.split(',');

      for (var j = 0; j < urls.length; j++) {
        let url = urls[j];

        if (siteUrl.includes(url)) {
          return data;
        }
      }
    }
  }

  return null;
};

const getHostName = (url) => {
  var l = document.createElement('a');

  if (!url.includes('http://') && !url.includes('https://')) {
    url = `https://${url}`;
  }

  url = url.replace('www.', '');
  l.href = url;
  return l.hostname.toLowerCase();
};

const weblinkMatchesRating = (weblink, rating) => {
  if (weblink && weblink != '' && rating.site_url && rating.site_url != '') {
    try {
      return getHostName(rating.site_url) == getHostName(weblink);
    } catch {}
  }

  return false;
};

const recObjectMatchesRating = (recObject, rating) => {
  if (
    recObject &&
    recObject.affiliate_url &&
    recObject.affiliate_url != '' &&
    recObject.weblink &&
    recObject.weblink != '' &&
    rating &&
    rating.site_url &&
    rating.site_url != ''
  ) {
    return weblinkMatchesRating(recObject.weblink, rating);
  }

  return false;
};

const isAmazonRatingWithoutMatchingWeblink = (recObject, ratingConfig) => {
  return (
    ratingConfig &&
    ratingConfig.name === 'Amazon' &&
    recObject &&
    ((recObject.weblink && !recObject.weblink.includes('amazon.')) ||
      (recObject.website && !recObject.website.includes('amazon.')))
  );
};

const shouldShowRating = (recObject, rating, ratingConfig, forceShowRating = false) => {
  if (isAmazonRatingWithoutMatchingWeblink(recObject, ratingConfig)) {
    return false;
  }

  return (
    rating &&
    ratingConfig &&
    (!recObject ||
      recObjectMatchesRating(recObject, rating) ||
      rating.is_affiliate ||
      rating.affiliate_url ||
      !recObject.affiliate_url) &&
    (forceShowRating || rating.rating >= MIN_RATING_TO_SHOW)
  );
};

const convertStarToHtml = (ratingNumber, svg, currentStar, ratingConfig, colorConfig, mobile) => {
  svg = jQuery(svg);

  if (mobile) {
    svg.css('height', '18px');
    svg.css('width', '18px');
  } else {
    svg.css('height', '20px');
    svg.css('width', '20px');
  }

  svg.css('zoom', '0.9');

  let method = ratingToColor[ratingNumber];
  let color = method && colorConfig[method];

  if (color && color != '') {
    var currentColor =
      svg.find('circle').attr('stroke') || svg.find('circle').attr('fill') || svg.find('path:last').attr('fill');

    if (currentColor && currentColor != '') {
      try {
        svg = jQuery(svg[0].outerHTML.replaceAll(currentColor, color));
      } catch {
        Log.info(`Failed to replace SVG color for rating | ${ratingConfig['name']}`, true);
      }
    }
  }

  if (currentStar != 0) {
    svg.css('margin-left', `${ratingConfig.space_between_icons}px`);
  }

  return svg[0].outerHTML;
};

const convertToHtml = (rating, ratingConfig, mobile = false) => {
  if (!ratingConfig) {
    return '';
  }

  // has to be between 0 and 5
  let ratingNumber = Math.max(Math.min(parseFloat(rating.rating) || MIN_RATING, MAX_RATING), MIN_RATING);

  ratingNumber = Math.ceil(ratingNumber * 2) / 2;
  let nearestWhole = Math.floor(ratingNumber);
  let isHalf = ratingNumber - nearestWhole !== 0;
  let emptyStars = 5 - Math.ceil(ratingNumber);

  let stars = [];
  let currentStar = 0;

  for (let i = 0; i < nearestWhole; i++) {
    stars.push(
      convertStarToHtml(ratingNumber, ratingConfig.full_star, currentStar, ratingConfig, ratingConfig.colors, mobile)
    );
    currentStar += 1;
  }

  if (isHalf) {
    stars.push(
      convertStarToHtml(ratingNumber, ratingConfig.half_star, currentStar, ratingConfig, ratingConfig.colors, mobile)
    );
    currentStar += 1;
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(convertStarToHtml(ratingNumber, ratingConfig.empty_star, currentStar, ratingConfig, {}, mobile));
    currentStar += 1;
  }

  return stars.join('');
};

const convertLogoToHtml = (rating, ratingConfig, mobile = false) => {
  if (!ratingConfig || !ratingConfig.logo_svg) {
    return '';
  }

  let svg = jQuery(ratingConfig.logo_svg);

  if (mobile) {
    svg.css('transform', `translateY(${ratingConfig.mobile_top_margin || 0}px)`);
  }

  return svg[0].outerHTML;
};

// if weblink is passed, it will try to match the link (if its not a review only rating)
const findBestRatingToShow = (ratings, config, user, weblink = null) => {
  let highestRatingCount = 0;
  let highestRatingNumber = 0;
  let selected = {};

  ratings = ratings.filter((x) => {
    return x.score >= MIN_RATING_TO_SHOW;
  });

  ratings = ratings.filter((r) => {
    let ratingConfig = configDataForRating(r, config);
    r.config = ratingConfig;
    return ratingConfig;
  });

  if (weblink) {
    ratings = ratings.filter((r) => {
      return r.config.review_site_only || weblinkMatchesRating(weblink, r);
    });
  }

  if (user && user.affiliate_links_enabled) {
    let affiliateRatings = ratings.filter((x) => {
      return x.is_affiliate;
    });

    if (affiliateRatings.length > 0) {
      ratings = affiliateRatings;
    }
  }

  ratings.forEach((rating) => {
    let score = rating.score;
    let numberOfRatings = rating.number_of_ratings;
    let siteUrl = rating.site_url;

    if (score > highestRatingCount || (score == highestRatingCount && numberOfRatings > highestRatingNumber)) {
      selected = {
        rating: score,
        number_of_reviews: numberOfRatings,
        site_url: siteUrl,
        is_affiliate:
          user && user.affiliate_links_enabled && (rating.is_affiliate || (rating.affiliate_url ? true : false)),
        affiliate_url: rating.affiliate_url,
      };

      highestRatingCount = score;
      highestRatingNumber = numberOfRatings;
    }
  });

  return selected;
};

const getRatingUrl = (recObject, rating) => {
  let url = rating.site_url;

  if (recObject && recObject.affiliate_links_enabled && rating.affiliate_url && rating.affiliate_url != '') {
    url = rating.affiliate_url;
  } else if (recObjectMatchesRating(recObject, rating)) {
    url = recObject.affiliate_url;
  }

  return url.includes('http') ? url : `https://${url}`;
};

export default {
  shouldShowRating,
  configDataForRating,
  convertToHtml,
  convertLogoToHtml,
  findBestRatingToShow,
  getRatingUrl,
};
